var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-group',{staticClass:"data-table-search-box",attrs:{"glyph":_vm.glyph,"glyph-position":"right"}},[_c('input',{ref:"field",staticClass:"form-input",attrs:{"id":_vm.identifier,"type":"text","name":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"focus":_vm.autoselect,"keydown":_vm.keydown}})])
}
var staticRenderFns = []

export { render, staticRenderFns }